import { render, staticRenderFns } from "./chat-user.vue?vue&type=template&id=5f532434&lang=html"
import script from "./chat-user.vue?vue&type=script&lang=js"
export * from "./chat-user.vue?vue&type=script&lang=js"
import style0 from "./chat-user.vue?vue&type=style&index=0&id=5f532434&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports